export function openFileInTab(file, tab) {
  const objURL = URL.createObjectURL(file)

  tab.location = objURL
  tab.document.title = file.name

  const setTitle = () => {
    tab.removeEventListener('load', setTitle)

    setTimeout(() => {
      tab.document.title = file.name
    }, 500)
  }

  tab.addEventListener('load', setTitle)

  checkAndKillObjURL(tab, objURL)
}

export function checkAndKillObjURL(tab, objURL) {
  let isClosed = null

  try {
    isClosed = tab.closed
  } catch (err) {
    isClosed = true
  }

  if (isClosed) {
    URL.revokeObjectURL(objURL)
  } else {
    setTimeout(() => checkAndKillObjURL(tab, objURL), 5000)
  }
}
